import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';

import type { CustomerRegisterApi } from '../services/customer-register-api/customer-register-api.types';

import customerRegisterApi from '../services/customer-register-api/customer-register-api';

export default function useCustomerRegistrationDetails(projectId: Ref<null | string | undefined>) {
  const queryKey = computed(() => ['customer-registration-details', projectId.value]);

  const queryFn = async (): Promise<CustomerRegisterApi.RegistrationDetailsResponse | null> => {
    if (!projectId.value) return null;

    return customerRegisterApi.getRegistrationDetails({ projectId: projectId.value });
  };

  return useQuery({
    enabled: computed(() => Boolean(projectId.value)),
    queryFn,
    queryKey,
    retry: 3,
  });
}
